import { Component, OnInit } from '@angular/core';
import { translate } from '@jsverse/transloco';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
    selector: 'app-support-resources',
    templateUrl: './support-resources.component.html',
    styleUrls: ['./support-resources.component.scss'],
    standalone: false
})
export class SupportResourcesComponent implements OnInit {

  title = translate('SUPPORT.SUPPORT');
  tenant: any;
  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.tenant = 'https://dashboard.bankingcloud.temenos.com';
  }

}
